export class UpdateAwsPrivateLinkInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fqdn",
            "baseName": "fqdn",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupRules",
            "baseName": "securityGroupRules",
            "type": "Array<SecurityGroupRule>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateAwsPrivateLinkInput.attributeTypeMap;
    }
    constructor() {
    }
}
